import React from "react";
import { useAppTranslation } from "../i18n/useAppTranslation";
import { GlobeIcon, LANGUAGE_OPTIONS, useLanguageChoice } from "./LanguageSwitcher";
import { LANGUAGE_SWITCHING } from "../config";

// The menu's Language row. Its list opens in place under the row: the menu
// scrolls inside a box that would clip a floating list.
const MenuLanguageRow = () => {
  const { t } = useAppTranslation("common");
  const { currentOption, chooseLanguage } = useLanguageChoice();
  const [open, setOpen] = React.useState(false);
  const listId = "menu-language-list";

  return (
    <>
      <button
        type="button"
        className="d-flex mt-2 row-item align-items-center w-100 border-0 bg-transparent text-start"
        aria-expanded={open}
        aria-controls={listId}
        onClick={() => setOpen((value) => !value)}
      >
        <span
          className="d-inline-flex align-items-center justify-content-center"
          style={{ width: 26, height: 26, color: "#c4b380" }}
        >
          <GlobeIcon size={22} />
        </span>
        <span className="ms-2 dark-yellow">{t("language.label")}</span>
        <span className="ms-auto d-flex align-items-center gap-1 fs-small text-light">
          <span aria-hidden="true">{currentOption.flag}</span>
          <span lang={currentOption.code}>{currentOption.nativeLabel}</span>
          <span
            aria-hidden="true"
            style={{
              display: "inline-block",
              transform: open ? "rotate(180deg)" : undefined,
              transition: "transform 0.2s ease",
            }}
          >
            ▾
          </span>
        </span>
      </button>
      {open && (
        <div
          id={listId}
          role="listbox"
          aria-label={t("language.label")}
          className="d-flex flex-column gap-1 mt-1 mb-1 p-1"
          style={{
            marginInlineStart: 34,
            background: "rgba(0, 0, 0, 0.25)",
            border: "1px solid rgba(163, 126, 57, 0.45)",
            borderRadius: 8,
          }}
        >
          {LANGUAGE_OPTIONS.map((option) => {
            const selected = option.code === currentOption.code;
            const localName = t(option.labelKey, {
              defaultValue: option.nativeLabel,
            });
            return (
              <button
                key={option.code}
                type="button"
                role="option"
                aria-selected={selected}
                onClick={async () => {
                  await chooseLanguage(option.code);
                  setOpen(false);
                }}
                className="w-100 d-flex align-items-center justify-content-between gap-2 px-2 py-1 border-0"
                style={{
                  minHeight: 32,
                  color: selected ? "#ffdb8c" : "#dcdcdc",
                  fontWeight: selected ? 700 : 500,
                  fontSize: 13,
                  borderRadius: 6,
                  textAlign: "start",
                  background: selected
                    ? "rgba(163, 126, 57, 0.22)"
                    : "transparent",
                }}
              >
                <span className="d-flex align-items-center gap-2">
                  <span aria-hidden="true">{option.flag}</span>
                  <span lang={option.code}>{option.nativeLabel}</span>
                  {localName !== option.nativeLabel && (
                    <span className="opacity-75" style={{ fontSize: 11, fontWeight: 400 }}>
                      {localName}
                    </span>
                  )}
                </span>
                {selected && <span aria-hidden="true">✓</span>}
              </button>
            );
          })}
        </div>
      )}
    </>
  );
};

// Nothing where players cannot switch language (the play build; see LANGUAGE_SWITCHING).
const MenuLanguagePicker = () => (LANGUAGE_SWITCHING ? <MenuLanguageRow /> : null);

export default MenuLanguagePicker;
